var _style, _defs, _defs2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatalink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 224 56",
    style: {
      enableBackground: "new 0 0 224 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000134211409909404813390000012206864377558593442_);}\n\t.st1{clip-path:url(#SVGID_00000022533905073293619570000012505439759572337539_);}\n\t.st2{fill:#004E2B;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#00DD39;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 224,
    height: 56
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180346274034354951370000013928269982585810092_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000180346274034354951370000013928269982585810092_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000075849354660465124500000010212851775726437513_",
    y: 0,
    width: 56,
    height: 56
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009554206650625239620000011988263141057775744_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075849354660465124500000010212851775726437513_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000009554206650625239620000011988263141057775744_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.2,0H16.8C7.5,0,0,7.5,0,16.8v22.5C0,48.5,7.5,56,16.8,56h22.5C48.5,56,56,48.5,56,39.2V16.8 C56,7.5,48.5,0,39.2,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.9,8.1c-5.1,0-9.3,3.8-9.9,8.7h5.7c0.6-1.8,2.2-3.2,4.2-3.2c2.4,0,4.4,2,4.4,4.4c0,2-1.3,3.7-3.2,4.2V28 c4.9-0.6,8.7-4.8,8.7-9.9C47.9,12.6,43.4,8.1,37.9,8.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18.1,47.9c5.1,0,9.3-3.8,9.9-8.7h-5.7c-0.6,1.8-2.2,3.2-4.2,3.2c-2.4,0-4.4-2-4.4-4.4c0-2,1.3-3.7,3.2-4.2 V28c-4.9,0.6-8.7,4.8-8.7,9.9C8.1,43.4,12.6,47.9,18.1,47.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M33.6,22.4v6.2c0,2.7-2.2,4.9-4.9,4.9h-6.2v-6.2c0-2.7,2.2-4.9,4.9-4.9H33.6z"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.5,17.6h10.4c7.3,0,11.9,4.9,11.9,11.2c0,6.4-4.6,11.2-11.9,11.2H73.5V17.6z M78.9,35.2h4.8 c4.3,0,6.5-2.8,6.5-6.4c0-3.6-2.3-6.4-6.5-6.4h-4.8V35.2z M112.4,25v-2h5.1v17h-5.2v-2.2c-1.3,1.4-3.5,2.5-6,2.5 c-5,0-8.4-3.7-8.4-8.8c0-5.2,3.5-8.8,8.6-8.8C109,22.7,111.1,23.7,112.4,25z M107.7,36c2.9,0,4.7-1.8,4.7-4.5 c0-2.7-1.9-4.5-4.7-4.5c-2.8,0-4.7,1.8-4.7,4.5C102.9,34.2,104.8,36,107.7,36z M129.5,23h4.3v4.5h-4.3V40h-5.2V27.5h-3.8V23h3.8 v-4.7h5.2V23z M150.1,25v-2h5.1v17H150v-2.2c-1.3,1.4-3.5,2.5-6,2.5c-5,0-8.4-3.7-8.4-8.8c0-5.2,3.5-8.8,8.6-8.8 C146.7,22.7,148.8,23.7,150.1,25z M145.3,36c2.9,0,4.7-1.8,4.7-4.5c0-2.7-1.9-4.5-4.7-4.5c-2.8,0-4.7,1.8-4.7,4.5 C140.6,34.2,142.5,36,145.3,36z M165.6,40h-5.2V16.3h5.2V40z M173.4,19.6c-1.9,0-3-1-3-2.7c0-1.5,1.2-2.6,3-2.6c1.9,0,3,1,3,2.6 C176.5,18.5,175.3,19.6,173.4,19.6z M176,40h-5.1V23h5.1V40z M192.2,22.7c4.4,0,6.7,2.8,6.7,7.1V40h-5.2v-9.5 c0-2.2-1.3-3.5-3.4-3.5c-2.4,0-3.9,1.8-3.9,3.5V40h-2.6h-2.6V23h4.9l0.1,2.3C187.6,23.8,189.7,22.7,192.2,22.7z M216.5,23h6.8 l-8.4,7.1l8.2,9.9h-6l-5.6-6.9l-2.4,2V40h-5V16.3h5v13.5L216.5,23z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatalink);
export default __webpack_public_path__ + "static/media/datalink.72afed500e16d8519ff6a46275c2a499.svg";
export { ForwardRef as ReactComponent };